import CertificationNumber, { CertificationNumberLabel } from './CertificationNumber';
import CertificationExamFormat from './CertificationExamFormat';

export default function CertificationInfoWidget({
  info: {
    minimumApprovalLevel,
    examCompletionTimeLimit,
    numberOfExamQuestions,
    examQuestionFormats,
    linkToPracticeExam,
  },
}) {
  const hasMinimumApprovalLevel = minimumApprovalLevel !== null;
  const hasTimeLimit = examCompletionTimeLimit !== null;
  const hasNumberOfQuestions = numberOfExamQuestions !== null;
  const hasQuestionFormats = examQuestionFormats !== null;
  const hasPracticeExam = linkToPracticeExam !== null;

  return (
    <div className="flex flex-col rounded-xl bg-white shadow-xl">
      <h3 className="bg-gray-900 text-white px-6 py-4 rounded-t-xl inline-flex items-center space-x-2">
        <div className="font-medium text-lg">
          Examen de certificación
        </div>
      </h3>
      <div className="divide-y-2 divide-gray-100">
        <div className="space-y-2 p-6">
          {hasMinimumApprovalLevel && (
            <CertificationNumber
              label="Nivel mínimo"
              value={`${minimumApprovalLevel}%`}
            />
          )}
          {hasTimeLimit && (
            <CertificationNumber
              label="Tiempo límite"
              value={`${examCompletionTimeLimit} minutos`}
            />
          )}
          {hasNumberOfQuestions && (
            <CertificationNumber
              label="Preguntas"
              value={numberOfExamQuestions}
            />
          )}
        </div>
        {hasQuestionFormats && (
          <div className="flex flex-col space-y-3 p-6">
            <CertificationNumberLabel label="Formatos de las preguntas" textColorClassName="text-gray-900" className="font-semibold" />
            <CertificationExamFormat formats={examQuestionFormats} />
          </div>
        )}
      </div>
      {hasPracticeExam && (
        <div className="flex w-full bg-gray-100 p-6 rounded-b-xl">
          <a href={linkToPracticeExam} className="bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 transition ease-in-out duration-100 font-semibold text-base text-white rounded-full px-6 py-3 leading-none items-center flex w-full justify-center focus:outline-none" target="_blank" rel="noopener noreferrer">
            Realizar examen de práctica
          </a>
        </div>
      )}
    </div>
  );
}
